
























































import {Vue, Component} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class Login extends Vue {
    @Action('login') loginUser;
    @Action('logout') logout;
    isBusy = false;
    email = '';
    password = '';
    errorMessage = null;

    async created() {
        await this.logout();
    }

    async login() {
        this.isBusy = true;
        this.errorMessage = null;
        try {
          await this.loginUser({username: this.email, password: this.password});
          setTimeout(async () => await this.$router.push({path: '/dashboard'}), 1000);
        } catch (err) {
          this.errorMessage = this.$i18n.t('neuspesnaPrijava');
        } finally {
          this.isBusy = false;
        }
    }

    async resetPassword() {

    }
}
